import styled, { css } from 'styled-components';
import Typography from 'ggApp/shared/components/typography';

import { Paragraph, SubHeadline, SmallHeadline } from 'ggApp/shared/common/Typography';

const BulletList = styled.ul`
    list-style: disc;
    margin-bottom: 16px;
`;

const BulletPoints = styled.li`
    margin-left: 1em;
`;

const DescriptionText = styled(Paragraph)`
    padding: 16px 0px;
    color: ${({ theme }) => theme.colors['Level 5']};
`;

const ShortDescription = styled(SubHeadline)`
    margin-bottom: 16px;
`;

const DescriptionTitle = styled(SmallHeadline)`
    margin-bottom: 16px;
`;

const StyledTypography = styled(Typography)`
    ${({ theme }) => css(theme.typography.Paragraph)};
    color: ${({ theme }) => theme.colors.Foreground};
`;

export { BulletList, BulletPoints, DescriptionText, ShortDescription, DescriptionTitle, StyledTypography };
